export default __webpack_public_path__ + "static/media/Mark-5-Suit-09.e8ff5705.jpg";